module.exports = __webpack_public_path__ + "img/img4.694ec3f6.png";